import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-655cb1b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-container show",
  id: "panel-itemdet",
  style: {"padding":"8px","padding-top":"0"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-start w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "icon-stack icon-stack-lg",
      style: {"font-size":"24px"}
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-fill" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "他のユーザーがデータを変更している可能性があり、あなたの変更時にエラーが発生しました。"),
      /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, " このウインドウを閉じて、再度開いてください。 ")
    ])
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary",
  style: {"margin-bottom":"25px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-start w-100" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "icon-stack icon-stack-lg",
        style: {"font-size":"24px"}
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-fill" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "仕入請求書と関連する仕入明細を選択してください。選択された仕入明細は、自動的に支払確定になります。")
      ])
    ])
  ])
], -1))
const _hoisted_7 = {
  class: "row",
  id: "panel-det",
  style: {"overflow":"auto","max-height":"60vh"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_9 = { class: "col-xl-12" }
const _hoisted_10 = { class: "row undLine" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "受注番号", -1))
const _hoisted_12 = { class: "col-md-2 contCnt" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "案件名", -1))
const _hoisted_14 = { class: "col-md-8 contCnt" }
const _hoisted_15 = { class: "row ditTableFrame" }
const _hoisted_16 = {
  class: "supplier_list",
  id: "supplier_list",
  style: {"margin":"0px","padding":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_0" }, "選択"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_1" }, "行No"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_2" }, "請求No"),
    /*#__PURE__*/_createElementVNode("th", {
      id: "sort4SupplysHead",
      class: "fixhead headSiire cwS_3"
    }, " 計上月 "),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_5" }, "商品選択"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_5-1" }, "項目選択"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_5-2" }, "数量"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_6" }, "期間開始"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_6-1" }, "期間終了"),
    /*#__PURE__*/_createElementVNode("th", {
      id: "sort4SupplysHead_supplier",
      class: "fixhead headSiire cwS_7"
    }, " 仕入先 "),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_8" }, "金額"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_9" }, "消費税"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_9-2" }, "請求確認"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_10" }, "支払予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_11" }, "支払確定"),
    /*#__PURE__*/_createElementVNode("th", { class: "fixhead headSiire cwS_12" }, "備考")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_tableJyutu_row_supply = _resolveComponent("Mo_tableJyutu_row_supply")!
  const _component_Mo_modal_max_force = _resolveComponent("Mo_modal_max_force")!

  return (_openBlock(), _createBlock(_component_Mo_modal_max_force, { ref: "Mo_modal_selectType" }, {
    title: _withCtx(() => [
      _createTextVNode("仕入請求No紐付")
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.message4dataError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.proData.c_project_number), 1),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.proData.c_project_name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.supplys, (item) => {
                  return (_openBlock(), _createBlock(_component_Mo_tableJyutu_row_supply, {
                    key: item.c_supply_id,
                    onAlreadyLinked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alreadyLinkedError())),
                    item: item,
                    mastersData: _ctx.delegate4list,
                    disabledDates: null,
                    supplyInfo: {
                    isLinkMode: true,
                    doc: _ctx.docData,
                    pro2Doc: _ctx.getSelectedPro2Doc(),
                  }
                  }, null, 8, ["item", "mastersData", "supplyInfo"]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModalSupply()))
      }, " 閉じる ")
    ]),
    _: 1
  }, 512))
}